import Bowser from 'bowser'

import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import type { AnalyticsEvent, GlobalErrorHandler } from '..'

export class AnalyticsApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  initializeAnalyticsSession = async (version: string, featureName?: string) => {
    const browser = Bowser.getParser(window.navigator.userAgent)

    const { analytics_session } = await this.fetchInstance.post(ApiEndpoints.ANALYTICS_SESSION, {
      browser_name: browser.getBrowserName() || 'Unknown',
      browser_version: browser.getBrowserVersion() || '0.0.0',
      is_first_visit: false,
      product_name: 'Individual Widget',
      product_version: version,
    })
    if (!analytics_session) {
      return { analytics_session: null }
    }
    this.fetchInstance.post(ApiEndpoints.ANALYTICS_FEATURE_VISITS, {
      feature_visit: {
        analytics_session_guid: analytics_session.guid,
        feature_name: featureName ? featureName : 'Experiences',
        is_first_visit: analytics_session.is_first_visit,
      },
    })
    return { analytics_session }
  }

  sendAnalyticEvent = async (event: AnalyticsEvent) => {
    return this.fetchInstance.post(ApiEndpoints.ANALYTICS_EVENTS, event).catch((err) => {
      throw err
    })
  }

  sendAnalyticsPageview = async (event: any) => {
    return this.fetchInstance.post(ApiEndpoints.ANALYTICS_PAGEVIEWS, event).catch((err) => {
      throw err
    })
  }
}
